export default __webpack_public_path__ + "static/11.08-e4ef7b85cded75bfcea41ab2216c47e2.png";